import { IApplicationState } from '../../types/redux';

export const selectQueryString = (state: IApplicationState) => state.queryString;

export const selectQueryStringWithQMark = (state: IApplicationState) =>
  state.queryString ? `?${state.queryString}` : '';
